module.exports = __webpack_public_path__ + "static/media/icon_200.6335852b.svg";